module.exports = __webpack_public_path__ + "static/img/empty-upload-res.e4663b31.png";